import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../lib/store';
import { wsClient } from '../lib/ws';
import { startRinging } from '../lib/ringtones';

const TONES = ['clay', 'water', 'sage', 'plum', 'dune'] as const;
function toneFor(id: string) {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) | 0;
  return TONES[Math.abs(h) % TONES.length];
}
function initials(name: string): string {
  return name.split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase() ?? '').join('') || '?';
}

function PhoneUp() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.9v3a2 2 0 0 1-2.2 2 20 20 0 0 1-8.6-3.1 20 20 0 0 1-6.2-6.1A20 20 0 0 1 2 4.2 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.7.6 2.5a2 2 0 0 1-.5 2.1L7.9 9.4a16 16 0 0 0 6 6l1.1-1.2a2 2 0 0 1 2.1-.4c.8.3 1.6.5 2.5.6A2 2 0 0 1 22 16.9z" />
    </svg>
  );
}
function PhoneDown() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <g transform="rotate(135 12 12)">
        <path d="M22 16.9v3a2 2 0 0 1-2.2 2 20 20 0 0 1-8.6-3.1 20 20 0 0 1-6.2-6.1A20 20 0 0 1 2 4.2 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.7.6 2.5a2 2 0 0 1-.5 2.1L7.9 9.4a16 16 0 0 0 6 6l1.1-1.2a2 2 0 0 1 2.1-.4c.8.3 1.6.5 2.5.6A2 2 0 0 1 22 16.9z" />
      </g>
    </svg>
  );
}

export function IncomingCallOverlay() {
  const nav = useNavigate();
  const incoming = useStore((s) => s.incomingCall);
  const setIncoming = useStore((s) => s.setIncomingCall);
  const contacts = useStore((s) => s.contacts);

  useEffect(() => {
    if (!incoming) return;
    const stop = startRinging();
    return stop;
  }, [incoming]);

  if (!incoming) return null;
  const from = contacts.find((c) => c.id === incoming.from);
  const displayName = from?.displayName ?? incoming.fromName ?? 'Someone';

  function accept() {
    if (!incoming) return;
    nav(`/call/${incoming.callId}`);
  }
  function decline() {
    if (!incoming) return;
    wsClient.send({ type: 'call.decline', callId: incoming.callId });
    setIncoming(null);
  }

  return (
    <div className="incoming">
      <div className="avatar md" data-tone={from ? toneFor(from.id) : 'clay'}>
        {initials(displayName)}
      </div>
      <div className="who-text">
        <strong>{displayName}</strong>
        <span>is calling…</span>
      </div>
      <div className="incoming-btns">
        <button className="icon-btn hangup" onClick={decline} aria-label="Decline">
          <PhoneDown />
        </button>
        <button className="icon-btn answer" onClick={accept} aria-label="Answer">
          <PhoneUp />
        </button>
      </div>
    </div>
  );
}
